import { createFeatureSelector, combineReducers, Action } from '@ngrx/store';
import * as fromAdmins from './admin/admin.reducer';
import * as fromApiKeys from './api-keys/api-keys.reducer';
// import * as fromForm from './form/form.reducer';

export const feature = 'admin-panel';

export interface State {
  admins: fromAdmins.State;
  apiKeys: fromApiKeys.State;
  // form: fromForm.State;
}

export function reducer(state: State | undefined, action: Action) {
  return combineReducers({
    admins: fromAdmins.reducer,
    apiKeys: fromApiKeys.reducer,
    // form: fromForm.reducer,
  })(state, action);
}

export const selectState = createFeatureSelector<State>(feature);

export const getAdmins = (state: State) => state.admins;
export const getApiKeys = (state: State) => state.apiKeys;
// export const getForm = (state: State) => state.form;
